import { _ } from '../../../vendor'
import InboomaBaseView from '../InboomaBaseView'
import { Biscuit } from '../../utils'
import VoucherTypesSidebarTpl from '../../templates/vouchers/VoucherTypesSidebarTpl.html'

// @todo If any kind of filter shall be used, add SidebarFilterBehavior
// as e.g. in OrdersSidebarView.js
export default InboomaBaseView.extend({

    template : VoucherTypesSidebarTpl,
    el : '#inb-c-sidebar',

    templateContext () {
        return {
            _,
            client_id: Biscuit.get('user.client_id')
        }
    },

    ui : {
        toggleDiscountsView : '.toggle-discounts-view',
        toggleGiftCardsView : '.toggle-gift-cards-view',
    },

    events : {
        'click @ui.toggleDiscountsView' : '_mobileToggleDiscountsView',
        'click @ui.toggleGiftCardsView' : '_mobileToggleGiftCardsView',
    },

    _mobileToggleDiscountsView () {
        this.getUI('toggleDiscountsView').addClass('hide');
        this.getUI('toggleGiftCardsView').removeClass('hide');
    },

    _mobileToggleGiftCardsView () {
        this.getUI('toggleDiscountsView').removeClass('hide');
        this.getUI('toggleGiftCardsView').addClass('hide');
    },

    initialize () {
        this.render()
    },

    _toggleLeftBar () {
        // unused as no filters there

        this.$el.toggleClass('open');

    }
});